import { useMemorandumLogo } from "hooks/MemorandumLogo";
import { FormatDate } from "utils/dateUtils";
import "../../../styles/print.scss";
import { selectState } from "../main.slice";
import { useSelector } from "react-redux";
import { IAverageConsumption } from "Dashboard/scenes/Resources/domain/IAverageConsumption";
import { averageConsumption } from "Dashboard/scenes/Resources/helpers/resourceUtil";
import { FormatNumberOrNull, FormatNumberWithUnitOrNull } from "utils/numberUtils";

const PrintResourcesStatus = () => {
  const memorandumLogo = useMemorandumLogo();
  const { resourceStatus } = useSelector(selectState);

  const calcAverageConsumption = (consumption: IAverageConsumption) => {
    let avrgConsumption = averageConsumption(
      consumption
    ).split(" ");

    return avrgConsumption[0] + " " + avrgConsumption[1];
  };

  return (
    <div className="resources-print">
      <div className="resources-print-header">
        <div className="logo">
          {memorandumLogo && <img src={memorandumLogo} alt="" />}
        </div>
        <span>
          <h1>Stanje resursa na dan: </h1>
          <div>{FormatDate(new Date().toISOString())}</div>
        </span>
      </div>
      <div className="resources-print-content">
        <div className="resources-print-th">
          <div>brend, marka, tip</div>
          <div>trenutna zaduženja po projektu</div>
          <div>
            <span>{resourceStatus && FormatDate(resourceStatus.refuelOnDate)}</span>
            <label>datuma sipao gorivo</label>
          </div>
        </div>
        <div className="resources-print-t">
          {resourceStatus &&
            resourceStatus.resources.map((res, index) => (
              <div key={index} className="single-resource-print">
                <div>
                  <label>{res.name} </label>
                  <label>{res.registrationPlate}</label>
                  {res.latestAverageConsumption && (
                    <label>
                      &gt; {FormatDate(res.latestAverageConsumption.timeFrom)} -{" "}
                      {FormatDate(res.latestAverageConsumption.timeTo)} -{" "}
                      {FormatNumberWithUnitOrNull(res.latestAverageConsumption.distance, res.latestAverageConsumption.usageUnit.name)} -{" "}
                      {calcAverageConsumption(res.latestAverageConsumption)}
                    </label>
                  )}
                </div>
                <div>
                  {res.hasAlarm && (<label>*</label>)}
                  {res.charge && (
                    <p>
                      <b>
                        &gt;
                        {res.charge.project}
                      </b>
                      : {res.charge.employee},
                      {FormatDate(res.charge.dateCharge)},
                      {FormatNumberWithUnitOrNull(res.charge.usageAmount, res.charge.usageUnit?.name ?? '')}
                    </p>
                  )}
                </div>
                <div>{res.refuelOnDate && (
                  <>
                    <span className="strong">{'>' + FormatNumberOrNull(res.refuelOnDate.quantityAmount) + ' '}</span>
                    <span className="normal text-small">litara</span>
                  </>
                )}
                </div>
              </div>
            ))}
        </div>
        <div className="resources-print-f">
          <div className="span-label">
            <label>{FormatNumberOrNull(resourceStatus?.numberOfChargedResources)}</label>
            <label>ukupno zaduženih resursa</label>
          </div>
          <div className="span-label">
            <label>{FormatNumberOrNull(resourceStatus?.totalQuantityOfOutputFuel)}</label>
            <label>ukupno izdato nafte</label>
          </div>
          <div className="span-label">
            <label>{FormatNumberOrNull(resourceStatus?.totalQuantityOfOutputRest)}</label>
            <label>ukupno izdato ostalo</label>
          </div>
          <div className="span-label">
            <label>{FormatNumberOrNull(resourceStatus?.totalFuelInStock)}</label>
            <label>lager nafte</label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrintResourcesStatus;
